import { buildModelManager } from "../builder.js";
const DefaultShopifyAppPurchaseOneTimeSelection = {
  __typename: true,
  id: true,
  createdAt: true,
  name: true,
  price: true,
  shopId: true,
  shopifyCreatedAt: true,
  status: true,
  test: true,
  updatedAt: true
};
const modelApiIdentifier = "shopifyAppPurchaseOneTime";
const pluralModelApiIdentifier = "shopifyAppPurchaseOneTimes";
;
;
;
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultShopifyAppPurchaseOneTimeSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultShopifyAppPurchaseOneTimeSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultShopifyAppPurchaseOneTimeSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultShopifyAppPurchaseOneTimeSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultShopifyAppPurchaseOneTimeSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultShopifyAppPurchaseOneTimeSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultShopifyAppPurchaseOneTimeSelection,
    namespace: null
  }
];
operations.push(...[
  "create",
  "bulkCreate",
  "update",
  "bulkUpdate",
  "delete",
  "bulkDelete"
].map((operation) => ({
  type: "stubbedAction",
  functionName: operation,
  errorMessage: `The action ${operation} on model shopifyAppPurchaseOneTime does not have an api trigger and cannot be called from this api client. If you are the developer of this application and want api clients to call this action add an api trigger to the action. For more information see: https://docs.gadget.dev/guides/actions/triggers`,
  operationName: "",
  dataPath: "",
  actionApiIdentifier: operation,
  modelApiIdentifier,
  variables: {},
  reason: "MissingApiTrigger"
})));
const ShopifyAppPurchaseOneTimeManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultShopifyAppPurchaseOneTimeSelection,
  operations
);
export {
  DefaultShopifyAppPurchaseOneTimeSelection,
  ShopifyAppPurchaseOneTimeManager
};
//# sourceMappingURL=ShopifyAppPurchaseOneTime.js.map
